import {IComponent, Component, IsolatedScope, Bind, Trace, LogLevel, Ref} from "xm-ui";
import {IMessengerOptions} from "./IMessengerOptions";
import {MessengerComponent} from "./MessengerComponent";

import * as messengerContainerStyles from "../assets/messenger-container.css";
import * as messengerStyles from "../assets/messenger.css";

export class MessengerContainerComponent extends Component<IMessengerOptions> {
    private eventTarget: JQuery;

    public async render() {
        let options = this.options;
        let messengerStyles = options.messengerStyles;
        let {DisplayType = "popup-bottom-right"} = this.options.response!;
        let containerClass = `${this.options.classPrefix}container ${this.options.classPrefix}${DisplayType.toLowerCase().split(" ").join("-")}`;

        return (
            <div class={`${this.options.classPrefix}event-target`}>
                <style>{messengerContainerStyles}</style>
                <div class={containerClass}>
                    <IsolatedScope class={`${this.options.classPrefix}scope`} isolatedStyles={messengerStyles}>
                        <MessengerComponent {...options}/>
                    </IsolatedScope>
                </div>
            </div>
        );
    }

    @Bind("hide", `[isolated-scope]`)
    @Trace(LogLevel.Info)
    public hide() {
        this.destroy();
        this.getHostElement().remove();
    }

    protected getDefaultOptions(): Partial<IMessengerOptions> {
        return $.extend(super.getDefaultOptions(), {
            messengerStyles: messengerStyles,
            classPrefix: "abc-messenger-",
            minScreenHeight: 768
        });
    }

    protected getEventTarget(): JQuery {
        return this.eventTarget;
    }

    @Trace(LogLevel.Info)
    protected onMount() {
        this.eventTarget = this.getHostElement()
            .find(`.${this.options.classPrefix}container`);

        this.fireEvent("mount");
    }

    @Bind("resized", "[isolated-scope]")
    @Trace(LogLevel.Info)
    private onMessengerResized(e: JQueryEventObject, owner: IComponent, messengerHeight: number) {
        if (messengerHeight && screen.height >= this.options.minScreenHeight!) {
            let cssMaxHeight = parseInt(this.getEventTarget().css('max-height')) || this.getEventTarget().outerHeight();
            let cssMinHeight = parseInt(this.getEventTarget().css('min-height')) || this.getEventTarget().height();

            if (messengerHeight < cssMinHeight)
                messengerHeight = cssMinHeight;

            if (messengerHeight < cssMaxHeight) {
                this.getEventTarget().attr("style", `max-height: ${messengerHeight}px !important`);
            }
        }

        this.eventTarget.addClass(`${this.options.classPrefix}visible`)
    }
}



// WEBPACK FOOTER //
// ./components/MessengerContainerComponent.tsx